export default "__VITE_ASSET__7gJ5Zpzd__"